/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Heatingnetworks1Inputs */



/**
* | output |
* | --- |
* | "Heating network(s)" |
*
* @param {Br_History_Key_Heatingnetworks1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_heatingnetworks1 = /** @type {((inputs?: Br_History_Key_Heatingnetworks1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Heatingnetworks1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heating network(s)")
	return /** @type {LocalizedString} */ ("Réseau(x)")
});
export { br_history_key_heatingnetworks1 as "br_history_key_heatingNetworks" }